import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreparingComponent } from './preparing.component';
import { LoadingModule } from '../loading/loading.module';
import { LoadingErrorModule } from '../loading-error/loading-error.module';
import { NotFoundModule } from '../not-found/not-found.module';


@NgModule({
    declarations: [PreparingComponent],
    imports: [
        CommonModule,
        LoadingModule,
        LoadingErrorModule,
        NotFoundModule
    ],
    exports: [
        PreparingComponent
    ]
})
export class PreparingModule {
}
